var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.115875776,6.8813913 C0.115875776,10.6134658 3.14156522,13.6389565 6.87363975,13.6389565 C10.605913,13.6389565 13.6314037,10.6134658 13.6314037,6.8813913 C13.6314037,3.14911801 10.605913,0.123428571 6.87363975,0.123428571 C3.14156522,0.123428571 0.115875776,3.14911801 0.115875776,6.8813913 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FICC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Disclaimer---language-options",
    transform: "translate(-448.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lang",
    transform: "translate(448.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4184 12.4184,16 8,16 C3.5818,16 0,12.4184 0,8 C0,3.5818 3.5818,0 8,0 C12.4184,0 16,3.5818 16,8",
    id: "Fill-113",
    fill: "#336581"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-122",
    transform: "translate(1.142857, 1.142857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-116"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-115",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "-3.29619876 13.6389565 4.45535404 13.6389565 4.45535404 8.27249689 -3.29619876 8.27249689"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-117",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "-3.29619876 5.49008696 4.45535404 5.49008696 4.45535404 0.123627329 -3.29619876 0.123627329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "7.23796273 13.6389565 19.9660124 13.6389565 19.9660124 8.27249689 7.23796273 8.27249689"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-119",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "7.23796273 5.49008696 19.9660124 5.49008696 19.9660124 0.123627329 7.23796273 0.123627329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "4.45535404 15.1395776 7.23796273 15.1395776 7.23796273 0.123428571 4.45535404 0.123428571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-121",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-3.49495652 8.27269565 22.2483478 8.27269565 22.2483478 5.49008696 -3.49495652 5.49008696"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDk);
export default __webpack_public_path__ + "static/media/DK.667f52b68eecd9a04616264315d6bb26.svg";
export { ForwardRef as ReactComponent };